#import "~/graphql/fragments/assets/defaultImageAsset.graphql"

query getTeamMembers(
    $site: [String!]
    $relatedToCategories: [CategoryRelationCriteriaInput]
) {
    entries(
        site: $site
        section: "teamMembers"
        relatedToCategories: $relatedToCategories
    ) {
        ... on teamMembers_default_Entry {
            title
            email: plainEmail
            phoneNumber: plaintext
            function: plaintext2
            department: selectTeamDepartment {
                title
            }
            showInOverview: plainSwitch2
            showLink: plainSwitch
            uri
            image {
                ... DefaultImageAsset
            }
        }
    }
}
